import { buildTask as _buildTask } from "ember-concurrency/-private/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
import { parseErrorForDisplay } from 'garaje/utils/flash-promise';
import uniq from 'lodash/uniq';
const SUCCESS_MESSAGE = 'Saved!';
function toOxfordComma(arr) {
  // clone to avoid mutation
  const fragments = [...arr];
  if (!fragments.length) {
    return '';
  }
  if (fragments.length === 1) {
    return fragments[0];
  }
  if (fragments.length === 2) {
    return `${fragments[0]} and ${fragments[1]}`;
  }
  const last = fragments.pop();
  return `${fragments.join(', ')}, and ${last}`;
}

/**
 * @param {Model<CompanyConfig>}                companyConfig
 * @param {Model<RoomLocationConfig>}           roomLocationConfig
 */
let RoombaSettingsIpadStatusComponent = (_class = class RoombaSettingsIpadStatusComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "flashMessages", _descriptor, this);
    _initializerDefineProperty(this, "roombaMetrics", _descriptor2, this);
    _initializerDefineProperty(this, "state", _descriptor3, this);
    _initializerDefineProperty(this, "graphql", _descriptor4, this);
    _initializerDefineProperty(this, "isEditing", _descriptor5, this);
    _defineProperty(this, "toggleLocalAdminNotifications", _buildTask(() => ({
      context: this,
      generator: function* () {
        try {
          const config = this.args.roomLocationConfig;
          this.roombaMetrics.trackEvent('device_notifications_for_local_admins_toggled', {
            locationAdminNotificationsEnabled: !config.roomsShouldEmailLocationAdmins,
            globalAdminNotificationsEnabled: config.roomsShouldEmailGlobalAdmins,
            notificationEmails: config.roomsNotificationEmails,
            ...this.commonMetricsParameters
          });
          yield this.graphql.updateRoomsLocationShouldEmailLocationAdmins(config.id, !config.roomsShouldEmailLocationAdmins);
          this.flashMessages.showAndHideFlash('success', SUCCESS_MESSAGE);
        } catch (e) {
          this.flashMessages.showAndHideFlash('error', parseErrorForDisplay(e));
        }
      }
    }), {
      drop: true
    }, "toggleLocalAdminNotifications", null));
    _defineProperty(this, "toggleGlobalAdminNotifications", _buildTask(() => ({
      context: this,
      generator: function* () {
        try {
          const config = this.args.roomLocationConfig;
          this.roombaMetrics.trackEvent('device_notifications_for_global_admins_toggled', {
            locationAdminNotificationsEnabled: config.roomsShouldEmailLocationAdmins,
            globalAdminNotificationsEnabled: !config.roomsShouldEmailGlobalAdmins,
            notificationEmails: config.roomsNotificationEmails,
            ...this.commonMetricsParameters
          });
          yield this.graphql.updateRoomsLocationShouldEmailGlobalAdmins(config.id, !config.roomsShouldEmailGlobalAdmins);
          this.flashMessages.showAndHideFlash('success', SUCCESS_MESSAGE);
        } catch (e) {
          this.flashMessages.showAndHideFlash('error', parseErrorForDisplay(e));
        }
      }
    }), {
      drop: true
    }, "toggleGlobalAdminNotifications", null));
    _defineProperty(this, "saveEmail", _buildTask(() => ({
      context: this,
      generator: function* (emails) {
        try {
          const uniqueEmails = uniq(emails);
          this.roombaMetrics.trackEvent('device_notifications_additional_emails_updated', {
            additionalEmails: uniqueEmails,
            ...this.commonMetricsParameters
          });
          yield this.graphql.updateRoomsLocationNotificationEmails(this.args.roomLocationConfig.id, uniqueEmails);
          this.flashMessages.showAndHideFlash('success', SUCCESS_MESSAGE);
        } catch (e) {
          this.flashMessages.showAndHideFlash('error', parseErrorForDisplay(e));
        }
      }
    }), {
      drop: true
    }, "saveEmail", null));
  }
  get sentenceFragments() {
    const fragments = [];
    const {
      roomsShouldEmailGlobalAdmins: globalAdminNotificationsEnabled,
      roomsShouldEmailLocationAdmins: locationAdminNotificationsEnabled,
      roomsNotificationEmails: notificationEmails
    } = this.args.roomLocationConfig;
    if (globalAdminNotificationsEnabled) {
      fragments.push('global admins');
    }
    if (locationAdminNotificationsEnabled) {
      fragments.push('location admins');
    }
    if (notificationEmails?.length) {
      fragments.push('specified email addresses');
    }
    return fragments;
  }
  get dynamicDescription() {
    if (!this.sentenceFragments.length) {
      return 'Device notifications are currently disabled.';
    }
    return `Device notifications will be sent to ${toOxfordComma(this.sentenceFragments)}.`;
  }
  get commonMetricsParameters() {
    return {
      locationId: this.state.currentLocation?.id
    };
  }
  toggleEditing() {
    this.isEditing = !this.isEditing;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "flashMessages", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "roombaMetrics", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "state", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "graphql", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isEditing", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "toggleEditing", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleEditing"), _class.prototype)), _class);
export { RoombaSettingsIpadStatusComponent as default };